import {
  MINUTES, HOURLY, DAILY, WEEKLY, MONTHLY, SEMIMONTHLY, YEARLY,
  ensureTwoDaysForSemiMonth
} from '../utils/recurrence';

export const types = {
  MINUTES,
  HOURLY,
  DAILY,
  WEEKLY,
  MONTHLY,
  YEARLY,
  SEMIMONTHLY,
  AT_TIME: 'AT_TIME',
  ADD_DAY_WEEK: 'ADD_DAY_WEEK',
  SET_WEEK: 'SET_WEEK',
  REMOVE_DAY_WEEK: 'REMOVE_DAY',
  ADD_DAY_MONTH: 'ADD_DAY_MONTH',
  UPDATE_DAY_MONTH: 'UPDATE_DAY_MONTH',
  REMOVE_DAY_MONTH: 'REMOVE_DAY_MONTH',
  UPDATE_DAY_SEMI_MONTH: 'UPDATE_DAY_SEMI_MONTH',
  ADD_DAY_YEAR: 'ADD_DAY_YEAR',
  UPDATE_DAY_YEAR: 'UPDATE_DAY_YEAR',
  REMOVE_DAY_YEAR: 'REMOVE_DAY_YEAR'
};

export default function reducer(state, action) {
  switch (action.type) {
    case types.MINUTES: {
      return { ...state, nMinutes: action.response };
    }
    case types.HOURLY: {
      return { ...state, nHours: action.response };
    }
    case types.WEEKLY: {
      return { ...state, nWeeks: action.response };
    }
    case types.MONTHLY: {
      return { ...state, nMonths: action.response };
    }
    case types.SEMIMONTHLY: {
      return { ...ensureTwoDaysForSemiMonth(state), nSemiMonths: action.response };
    }
    case types.AT_TIME: {
      return { ...state, atTime: action.response };
    }
    case types.ADD_DAY_MONTH: {
      return {
        ...state,
        daysInMonth: [
          ...state.daysInMonth.slice(0, action.index),
          action.response,
          ...state.daysInMonth.slice(action.index)
        ]
      };
    }
    case types.UPDATE_DAY_MONTH: {
      return {
        ...state,
        daysInMonth: state.daysInMonth.map(
          (value, index) => (index === action.index ? action.response : value)
        )
      };
    }
    case types.UPDATE_DAY_SEMI_MONTH: {
      return {
        ...state,
        daysInSemiMonth: state.daysInSemiMonth.map(
          (value, index) => (index === action.index ? action.response : value)
        )
      };
    }
    case types.REMOVE_DAY_MONTH: {
      return { ...state, daysInMonth: state.daysInMonth.filter(day => day.id !== action.response) };
    }
    case types.ADD_DAY_WEEK: {
      if (state.daysInWeek === undefined) {
        return {
          ...state,
          daysInWeek: [action.response].sort()
        };
      }
      return {
        ...state,
        daysInWeek: [...state.daysInWeek, action.response].sort()
      };
    }
    case types.REMOVE_DAY_WEEK: {
      return { ...state, daysInWeek: state.daysInWeek.filter(day => day !== action.response) };
    }
    case types.SET_WEEK: {
      return { ...state, daysInWeek: action.response };
    }
    case types.ADD_DAY_YEAR: {
      return {
        ...state,
        daysInYear: [
          ...state.daysInYear.slice(0, action.index),
          action.response,
          ...state.daysInYear.slice(action.index)
        ]
      };
    }
    case types.UPDATE_DAY_YEAR: {
      return {
        ...state,
        daysInYear: state.daysInYear.map(
          (value, index) => (index === action.index ? action.response : value)
        )
      };
    }
    case types.REMOVE_DAY_YEAR: {
      return { ...state, daysInYear: state.daysInYear.filter(day => day.id !== action.response) };
    }
    default: {
      return state;
    }
  }
}
